/**
 * Utility functions for order-related operations
 */

/**
 * Format price to two decimal places
 * @param {number|string} price - The price to format
 * @returns {string} - Formatted price with two decimal places
 */
export const formatPrice = (price) => {
    return parseFloat(price || 0).toFixed(2);
  };
  
  /**
   * Format number with thousands separator
   * @param {number} num - The number to format
   * @returns {string} - Formatted number with thousands separator
   */
  export const formatNumber = (num) => {
    return num?.toFixed(2)
      .replace(/\B(?=(\d{3})+(?!\d))/g, '.');
  };
  
  /**
   * Extract time information from an order
   * @param {Object} record - Order record
   * @returns {Object} - Object containing arrival and completion times
   */
  export const extractTimeFromOrder = (record) => {
    let arrivalTime = null;
    let completionTime = null;
  
   
  
    // Then check order_products (this seems to be the more reliable source)
    if ((!arrivalTime || !completionTime) && record.order_products && record.order_products.length > 0) {
      arrivalTime = record.order_products[0].order_property_arrival_time || arrivalTime;
      completionTime = record.order_products[0].order_property_completion_time || completionTime;
    }
  
    return { arrivalTime, completionTime };
  };
  
  /**
   * Check whether an unfinished order is missing its scheduling task ID.
   * @param {Object} order - Order record
   * @returns {boolean} - True if order has scheduling issues
   */
  export const hasSchedulingIssue = (order) => {
    const status = String(order?.order_status || '').trim().toLowerCase();
    if (['completed', 'collected', 'cancelled'].includes(status)) return false;
    return !order.task_id || order.task_id === "";
  };
  
  /**
   * Get color code for order status
   * @param {string} status - Order status
   * @returns {string} - Color code for the status
   */
  export const getStatusColor = (status) => {
    switch (status) {
      case 'Scheduled': return 'blue';
      case 'En-route':
      case 'On-Route': return 'orange';
      case 'Completed': return 'green';
      case 'Collected': return 'purple';
      case 'Cancelled': return 'red';
      case 'Failed': return 'volcano';
      default: return 'default';
    }
  };

  export const blockChangeStatus = (status) => {
  const statusesToNotAllow = [ 'Collected', 'Cancelled', 'Failed'];
  //if is in the list and if Cancell
  return statusesToNotAllow.includes(status);
};
  
  /**
   * Format date string to YYYY-MM-DD format
   * @param {Date} date - Date object
   * @returns {string} - Formatted date string
   */
  export const formatDate = (date) => {
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const day = String(date.getDate()).padStart(2, '0');
    return `${year}-${month}-${day}`;
  };
  
  /**
   * Get default date range based on mode and date
   * @param {string} mode - Date view mode ('today', 'week', 'month')
   * @param {Date} date - Current date
   * @returns {Array} - Array with start and end dates
   */
  export const getDefaultDateRange = (mode, date) => {
    const startDate = new Date(date);
    const endDate = new Date(date);
  
    if (mode === 'today') {
      // For "today" mode, both start and end date are the same date
    } else if (mode === 'week') {
      const day = startDate.getDay(); // 0 = Sunday, 1 = Monday, etc.
      startDate.setDate(startDate.getDate() - day); // Set to previous Sunday
      endDate.setDate(startDate.getDate() + 6); // Set to Saturday
    } else if (mode === 'month') {
      startDate.setDate(1); // First day of the month
      endDate.setMonth(endDate.getMonth() + 1, 0); // Last day of the month
    }
  
    return [
      formatDate(startDate),
      formatDate(endDate)
    ];
  };
